import MyHeader from "./pc/MyHeader";
import MobileHeader from "./mb/MobileHeader";
import MobileFooter from "./mb/MobileFooter";
import MyFooter from "./pc/MyFooter";
import utils from "../../utils";
import React from "react";
import styles from './layout.module.scss'

const Layout = ({
  children,
  hideHome,
  allBlue = true,
  showHeader = true,
  isTransparent = true,
}) => {
  return (
    <React.Fragment>
      <div className={styles.pc}>
        {showHeader && (
          <MyHeader
            hideHome={hideHome}
            allBlue={allBlue}
            isTransparent={isTransparent}
          ></MyHeader>
        )}
      </div>
      <div className={styles.mobile}>
        <MobileHeader></MobileHeader>
      </div>
      <main className={styles.main}>{children}</main>
      <div className={styles.pc}>
        <MyFooter></MyFooter>
      </div>
      <div className={styles.mobile}>
        <MobileFooter></MobileFooter>
      </div>
    </React.Fragment>
  );
};

export default Layout;
